import { useLanguageContextAPI } from '../../context/LanguageContext';

import DeSVG from '../../assets/locale/de.svg';
import EnSVG from '../../assets/locale/en.svg';
import { Button } from '@airbus/components-react';

const languageMap = {
  de: <img src={DeSVG} alt='DE' />,
  en: <img src={EnSVG} alt='EN' />,
};

export default function LanguageSwitcher() {
  const { language, changeLang } = useLanguageContextAPI();

  function toggleLanguageKeys() {
    changeLang(language === 'en' ? 'de' : 'en'); // getting changed by event listener cb at useTranslation();
  }
  return (
    <Button variant='ghostNegative' onClick={toggleLanguageKeys}>
      {language.toUpperCase()} &nbsp;
      {languageMap[language]}
    </Button>
  );
}
